import { connect } from 'react-redux';
import Global from '../../store/global-selectors';
import * as Actions from '../../store/shipments/shipments.actions';
import { AssignmentModal } from '../../components/modals/assignment-modal';
import get from 'lodash.get';
import { UserPermissionService } from '../../services/user-permission-service';

const mapStateToProps = (state, ownProps) => {
  const fulfillmentPlan = get(ownProps, 'fulfillmentPlan');
  const assignedUserId = get(fulfillmentPlan, 'assignedToUserId');

  const users = Global.selectSellerUsers(state).map((user) => ({
    ...user,
    isDisabled: !UserPermissionService.userHasShippingRole(get(user, 'roles')),
  }));
  const assignedUser = users.find((user) => get(user, 'userId') === assignedUserId) || undefined;
  return {
    users,
    hasMultipleUsersAssigned: false,
    assignToIds: [get(fulfillmentPlan, 'fulfillmentPlanId')],
    assignedUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAssign: (assignToIds, userId) => {
      dispatch(Actions.assignBulkFulfillmentPlanToUser(assignToIds, userId));
    },
  };
};

export const FulfillmentPlanAssignmentModalContainer = connect(mapStateToProps, mapDispatchToProps)(AssignmentModal);
